module.exports = __webpack_public_path__ + "static/media/vf_wshoes_core.7b7f70d2.svg";